import { Component, Renderer2, ElementRef, AfterViewInit,  OnInit, OnChanges, Input, Output, EventEmitter, ViewChild } from '@angular/core';

// models
import { BookingInitState } from '../../../models/booking-reducer.interface';
import { UserInitState } from '../../../../shared/models/user-reducer.interface';

declare var ga: any;

@Component({
  selector: 'app-standard-payment',
  templateUrl: './standard-payment.component.html',
  styleUrls: ['./standard-payment.component.scss']
})
export class StandardPaymentComponent implements OnInit, OnChanges, AfterViewInit {
  @Output() handlePaymentType = new EventEmitter<any>();
  @Output() handleSaveBillingAddress: EventEmitter<any> = new EventEmitter();

  @Input() paymenttype;
  @Input() bookingState: BookingInitState;
  @Input() user: UserInitState;
  @Input() price;
  @Input() oldprice;
  @Input() isVisible;
  @Input() appCopy;
  @Input() payByInvoice;
  @Input() overridePayment;
  @Input() billingAddressValid;
  @Input() billingAddress;
  @Input() flightDirection;
  @Input() isCustomerSupport;
  @Input() selectedLanguage;
  @Input() formData;
  @Input() PaymentTypeAvailable;
  @Input() bookingAmendType;

  @ViewChild('form') form;
  @ViewChild('billingAddressForm') billingAddressForm;

  public bookingProduct;
  public bookingType;
  public subscribeNewsletter = false;
  public userLoggedIn = false;
  public cardNumberFormatted = '';
  public billingAddressSame = true;
  public hasBillingAddress = true;
  public cardNumberPattern = /^[0-9\s]{12,23}$/;
  public expiryMonthPattern = /^(0?[1-9]|1[0-2])$/;
  public expiryYearPattern = /^(\d{2})$/;
  public cardSecurityPattern = /^[0-9]*$/;
  public formValues: any = {
    ccnumber: '',
    nameoncard: '',
    ccexpmonth: '',
    ccexpyear: '',
    CardSecurityCode: '',
    billingAddress: ''
  };

  constructor(private renderer: Renderer2, private elementRef: ElementRef) { }

  ngAfterViewInit() {
    const inputFields = this.elementRef.nativeElement.getElementsByClassName('noSpaces');

    for (let i = 0; i < inputFields.length; i++) {
      this.renderer.listen(inputFields[i], 'keydown', (event: KeyboardEvent) => {
        if (event.key === ' ') {
          event.preventDefault();
        }
      });
    }
  }

  ngOnInit() {
    this.bookingProduct = this.bookingState.bookingDetails.bookingProduct;
    this.hasBillingAddress = this.billingAddress !== null;
    this.billingAddressSame = this.billingAddress !== null;
    this.setUserValues();
    // this.handlePaymentType.emit(this.paymenttype);
    console.log(this.paymenttype);

    if (this.formData.set && (this.formData.data && this.formData.data.standardForm)) {
      this.formValues.ccnumber = this.formData.data.standardForm.ccnumber;
      this.formValues.nameoncard = this.formData.data.standardForm.nameoncard;
      this.formValues.ccexpmonth = this.formData.data.standardForm.ccexpmonth;
      this.formValues.ccexpyear = this.formData.data.standardForm.ccexpyear;
      this.formValues.CardSecurityCode = this.formData.data.standardForm.CardSecurityCode;
      this.formValues.billingFormData = this.formData.data.standardForm.billingFormData;

      this.hasBillingAddress = !this.formData.data.standardForm.billingForm;
    }

  }



  onSearchChange(searchValue: string): void {
    console.log(searchValue);

  }

  // on user changes
  // set user values
  ngOnChanges(changes: any) {
    if (changes.user) {
      if (!changes.user.firstChange) {
        this.user = changes.user.currentValue;
        this.setUserValues();

      }
    }

    if (changes.billingAddress) {
      this.billingAddress = changes.billingAddress.currentValue;
    }

    if (changes.billingAddressValid) {
      this.billingAddressValid = changes.billingAddressValid.currentValue;
    }
  }

  clickSaveCard(val: any) {
    if (val.currentTarget.checked === true) {
      ga('send', 'event', 'Vanilla', 'Pay - Card', 'Save');
    }

  }
  setUserValues() {
    this.userLoggedIn = this.user.userDetails.userLoggedIn;
    this.bookingType = this.bookingState.bookingDetails.bookingType;
  }

  sendPaymentType(value: number) {
    this.handlePaymentType.emit(value);
  }

  saveBillingAddress(address) {
    this.billingAddressSame = false;
    this.toggleBillingAddress();
    this.handleSaveBillingAddress.emit(address);
  }

  toggleBillingAddress() {
    this.hasBillingAddress = !this.hasBillingAddress;
  }

}
